import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '内容导航',
      links: [
        { label: '入门教程', to: '/category/rumen-jiaocheng' },
        { label: '技巧训练', to: '/category/jiqiao-xunlian' },
        { label: '进阶攻略', to: '/category/jinjie-gonglve' },
        { label: '常见误区', to: '/category/changjian-wuqu' },
        { label: '极限控制力训练', to: '/category/jixian-kongzhili' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '口碑评价', to: '/about#testimonials' },
        { label: '联系我们', to: '/about#contact' },
      ],
    },
    {
      title: '热门文章',
      links: [
        { label: '寸止挑战是什么', to: '/article/cunzhi-tiaozhan-shime' },
        { label: '七天训练计划', to: '/article/xinren-rumen-xunlian-jihua' },
        { label: '呼吸控制技巧', to: '/article/huxi-kongzhi-jiqiao' },
        { label: '高阶控制策略', to: '/article/gaojie-kongzhi-celve' },
        { label: '心理学原理', to: '/article/jixian-kongzhili-xinlixue' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-background-50 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-focus-3-line text-lg" />
              </div>
              <span className="text-lg font-semibold font-heading">寸止训练中心</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专注于极限控制力与专注度训练的专业平台。我们致力于帮助每一位挑战者突破自我极限，掌握真正的寸止精髓。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line" />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wide">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 寸止训练中心. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}